import assets from '@/assets';
import moment from 'moment';
import { http, rules, token, setting } from '@/utils';

function checkPermission(key, data) {
  const permissions = this.$store.state.user.school_role_permission_ids.route_names;

  // const bool = permissions
  //   .some(({ route_name }) => route_name === key);
  const bool = permissions.includes(key);

  return data === undefined ? bool : (bool && data);
}
function checkHttp() {
  const url = window.location.href;
  return url.indexOf('yunkeduntest') === -1 ? 'https://' : 'https://';
}

const mainMap = {
  localhost: {
    domain: 'yunkeduntest.com',
    yunkedun: 'https://www.yunkeduntest.com',
    h5: 'https://h5.yunkeduntest.com',
    eeop: 'https://eeop.yunkeduntest.com',
    editor: 'http://localhost:8082',
    courseware: 'https://management.courseware.yunkeduntest.com',
    schoolManagement: 'https://management.schoolweb.yunkeduntest.com',
    student: 'https://student.schoolweb.yunkeduntest.com',
    socket: 'https://socket.yunkeduntest.com',
    moat: 'https://moat.yunkeduntest.com',
  },
  'management.schoolweb.yunkeduntest.com': {
    domain: 'yunkeduntest.com',
    yunkedun: 'https://www.yunkeduntest.com',
    h5: 'https://h5.yunkeduntest.com',
    eeop: 'https://eeop.yunkeduntest.com',
    editor: 'https://editor.courseware.yunkeduntest.com',
    courseware: 'https://management.courseware.yunkeduntest.com',
    schoolManagement: 'https://management.schoolweb.yunkeduntest.com',
    student: 'https://student.schoolweb.yunkeduntest.com',
    socket: 'https://socket.yunkeduntest.com',
    moat: 'https://moat.yunkeduntest.com',
  },
  'management.schoolweb.yunkedun.com': {
    domain: 'yunkedun.com',
    yunkedun: 'https://www.yunkedun.com',
    h5: 'https://h5.yunkedun.com',
    eeop: 'https://eeop.yunkedun.com',
    editor: 'https://editor.courseware.yunkedun.com',
    courseware: 'https://management.courseware.yunkedun.com',
    schoolManagement: 'https://management.schoolweb.yunkedun.com',
    student: 'https://student.schoolweb.yunkedun.com',
    socket: 'https://socket.yunkedun.com',
    moat: 'https://moat.yunkedun.com',
  },
};

/* eslint-disable no-param-reassign */
export default {
  install(Vue) {
    Vue.prototype.$http = http;
    Vue.prototype.$setting = setting;
    Vue.prototype.$assets = assets;
    Vue.prototype.$rules = rules;
    Vue.prototype.$token = token;
    Vue.prototype.$permissions = checkPermission;
    Vue.prototype.$moment = moment;
    Vue.prototype.$domain = mainMap[window.location.hostname];
    Vue.prototype.$checkHttp = checkHttp;
  },
};



// WEBPACK FOOTER //
// ./src/plugins/index.js